import React from "react";
import "../styles/skills.css";

const skills = [
  { name: "Linux", icon: "linux" },
  { name: "Python", icon: "python" },
  { name: "Docker", icon: "docker" },
  { name: "JavaScript", icon: "javascript" },

  { name: "Git", icon: "git" },
  { name: "Node.js", icon: "nodedotjs" },
  { name: "Terraform", icon: "terraform" },
  { name: "Pandas", icon: "pandas" },

  { name: "React.js", icon: "react" },
  { name: "ML", icon: "scikitlearn" },
  { name: "AWS", icon: "amazonaws" },
  { name: "OpenCV", icon: "opencv" }
];

export default function Skills() {
  return (
    <section id="skills">
      <h2 className="section-title">
        My <span>Skills</span>
      </h2>
      <p className="section-subtitle">Technologies I've worked with</p>

      <div className="skills-grid">
        {/* Desktop view: 7 icons per row */}
        <div className="skills-row desktop-view">
          {skills.slice(0, 7).map(skill => (
            <div className="skill-card" key={skill.name}>
              <div className="skill-icon">
                <img
                  src={`https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/${skill.icon}.svg`}
                  alt={skill.name}
                />
              </div>
              <h4>{skill.name}</h4>
            </div>
          ))}
        </div>

        <div className="skills-row desktop-view">
          {skills.slice(7, 14).map(skill => (
            <div className="skill-card" key={skill.name}>
              <div className="skill-icon">
                <img
                  src={`https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/${skill.icon}.svg`}
                  alt={skill.name}
                />
              </div>
              <h4>{skill.name}</h4>
            </div>
          ))}
        </div>

        {/* Mobile view: 4 icons per row */}
        <div className="mobile-view">
          {skills.map(skill => (
            <div className="skill-card" key={skill.name}>
              <div className="skill-icon">
                <img
                  src={`https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/${skill.icon}.svg`}
                  alt={skill.name}
                />
              </div>
              <h4>{skill.name}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}